import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'
import React from 'react'

import { Error } from './Error'

export const Textarea: React.FC<
  TextField & {
    errors: Partial<FieldErrorsImpl>
    register: UseFormRegister<FieldValues>
    rows?: number
  }
> = ({ name, defaultValue, errors, label, register, required, rows = 4 }) => {
  return (
    <div className="field">
      <label htmlFor={name}>
        {label}
        {required && ' *'}
      </label>
      <textarea
        defaultValue={defaultValue}
        id={name}
        placeholder={label}
        rows={rows}
        {...register(name, { required })}
      />
      {errors[name] && <Error name={name} />}
    </div>
  )
}
